
// sticky header js

document.addEventListener("scroll", function () {
  const stickyHeader = document.querySelector(".itg_sticky_header_wrapper");
  
  if (window.scrollY > 200) { 
    stickyHeader?.classList.add("show");
  } else {
    stickyHeader?.classList.remove("show");
  }
});

// bc 2026-08-18: the expand/collapse state is owned by the whole sticky pill, not just the
// hamburger group. Previously the hamburger was display:none'd on expand, so the pointer sat
// over nothing for a frame -> mouseleave -> collapse -> mouseenter -> expand (flicker). Now:
// open on entering the pill (or focusing anything in it), close 220ms after leaving it.
document.querySelectorAll('.itg_sticky_header_wrapper .itg_sticky_header_inner_container').forEach(function(container) {
    var closeTimer = null;
    var settleTimer = null;
    var open = function() {
        clearTimeout(closeTimer);
        if (!container.classList.contains('active')) {
            // brief settle window: the nav slides in under the pointer; don't pop a flyout on arrival
            container.classList.add('bc-settling'); clearTimeout(settleTimer);
            settleTimer = setTimeout(function(){ container.classList.remove('bc-settling'); }, 350);
        }
        container.classList.add('active');
    };
    var scheduleClose = function() { clearTimeout(closeTimer); closeTimer = setTimeout(function(){ container.classList.remove('active'); }, 220); };
    var trigger = container.querySelector('.sticky_menu_contents') || container;
    trigger.addEventListener('mouseenter', open);
    container.addEventListener('mouseenter', function(){ if (container.classList.contains('active')) open(); });
    container.addEventListener('mouseleave', scheduleClose);
    container.addEventListener('focusin', open);
    container.addEventListener('focusout', function(e){ if (!container.contains(e.relatedTarget)) scheduleClose(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') container.classList.remove('active'); });
});

// sticky header js

// mobile nav menu drawer 


document.addEventListener("DOMContentLoaded", function() {
  // Open menu
  document.querySelector(".header-icons .itg_header_icons.mobile_menu_burger")
    .addEventListener("click", function(e) {
      let menuWrapper = e.target.closest(".itg_custom_header-menu");
      if (menuWrapper) {
        let innerMenu = menuWrapper.querySelector(".header-menu__inner");
        if (innerMenu) {
          innerMenu.classList.add("active");
          document.querySelector(".itg_header_inner_container").classList.add("hide_overflow");
        }
      }
    });

  // Close menu
  document.querySelectorAll(".header-menu__inner .mobile_drawer_cross_icon")
    .forEach(function(closeBtn) {
      closeBtn.addEventListener("click", function(e) {
        let innerMenu = e.target.closest(".header-menu__inner");
        if (innerMenu) {
          innerMenu.classList.remove("active");
          document.querySelector(".itg_header_inner_container").classList.remove("hide_overflow");
        }
      });
    });
});

// mobile drawer: submenus are a tap-to-open accordion (desktop keeps its hover flyouts)
(function () {
  var mobile = window.matchMedia("(max-width: 990px)");

  function setOpen(item, open) {
    item.classList.toggle("bc-open", open);
    var link = item.querySelector(":scope > .bc-nav__link");
    if (link) link.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function init() {
    document.querySelectorAll(".bc-nav").forEach(function (nav) {
      nav.classList.add("bc-acc");
      var first = nav.querySelector(".bc-has-sub");
      if (first && mobile.matches) setOpen(first, true);
    });
  }

  // Every parent's destination is repeated as its first child link, so on mobile the whole
  // parent row can be the toggle without losing a page.
  document.addEventListener("click", function (e) {
    if (!mobile.matches) return;
    var link = e.target.closest(".bc-has-sub > .bc-nav__link");
    if (!link) return;
    e.preventDefault();
    var item = link.parentElement;
    setOpen(item, !item.classList.contains("bc-open"));
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

// scroll trigger section

  document.addEventListener('DOMContentLoaded', () => {
      const sections = document.querySelectorAll('.scroll-trigger-section'); // Add this class to all target sections

      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  entry.target.classList.add('active_trigger'); // Add class when 50% visible
              } 
          });
      }, {
          root: null,
          threshold: 0.1 // Trigger when 50% of the section is visible
      });

      sections.forEach(section => observer.observe(section));
  });


  // lazy loading video


  document.addEventListener("DOMContentLoaded", function () {
  const lazyVideos = document.querySelectorAll("video.lazy-video");
 
  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
 
          const sources = video.querySelectorAll("source[data-src]");
          sources.forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute("data-src");
          });
 
          video.load();
          // video.play();  
 
          observer.unobserve(video);
        }
      });
    }, { threshold: 0.5 });
 
    lazyVideos.forEach(video => {
      videoObserver.observe(video);
    });
  }
});


// audio icon functionality on the video 


document.addEventListener("DOMContentLoaded", () => {

  const videoBlocks = document.querySelectorAll(".itg_video_block_wrapper");

  videoBlocks.forEach(block => {
    const audioIcon = block.querySelector(".audio_icon_wrapper");

    if (block.querySelector("video") && audioIcon) {
      audioIcon.addEventListener("click", () => {
        // bc 2026-10-05: the hero holds a desktop and a portrait <video>; only one is attached per device
        // (snippets/bc-video). The old code always took the first one in the DOM (desktop), so on phones the
        // button unmuted a video with no source and the hero stayed silent.
        const videos = Array.from(block.querySelectorAll("video"));
        const video = videos.find((v) => v.dataset.bcAttached) || videos[0];
        audioIcon.classList.toggle("active");
        video.muted = !video.muted;
      });
    }
  });
});

//  sticky product header js
  

// Observer and add to cart for product sticky header js


document.addEventListener("DOMContentLoaded", function () {

    const stickyHeaderSelector = '.sticky-product-header';
    const triggerSelector = '.itg_product_details_wrapper';
    const addToCartButtonSelector = '.sticky_product_header_addtoCart_btn';
    const activeClass = 'is-visible';

    const stickyHeader = document.querySelector(stickyHeaderSelector);
    const triggerElement = document.querySelector(triggerSelector);
    const addToCartBtn = stickyHeader?.querySelector(addToCartButtonSelector);

    if (!stickyHeader || !triggerElement) return;

    const toggleHiddenAtTop = () => {
      if (window.scrollY === 0) {
        // Always hide when at very top
        stickyHeader.classList.remove(activeClass);
        return true;
      }
      return false;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // If user is at very top, make sure header is hidden
          if (toggleHiddenAtTop()) return;

          // If trigger is intersecting viewport => hide header
          if (entry.isIntersecting) {
            stickyHeader.classList.remove(activeClass);
          } else {
            // Trigger left the viewport (we scrolled past it) => show header
            stickyHeader.classList.add(activeClass);
          }
        });
      },
      {
        root: null,
        threshold: 0,
        // Adjust rootMargin to tweak when the header appears.
        // Example below triggers when the bottom of the trigger leaves viewport.
        rootMargin: '0px 0px -100% 0px',
      }
    );

    observer.observe(triggerElement);

    // Extra guard: some browsers/edge cases may not fire observer immediately on page load.
    // This scroll listener ensures the top-of-page check always hides header when scrollY === 0.
    window.addEventListener('scroll', () => {
      // If user is at the top, ensure header is hidden
      if (window.scrollY === 0) {
        stickyHeader.classList.remove(activeClass);
      }
    });


  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", async function (event) {
      
      event.preventDefault();
      const button = event.target;
      if (!button || button.disabled) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = "Adding...";

      try {
        let variantId = null;

        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput) variantId = variantInput.value;
        }

        if (!variantId && window.product && window.product.variants && window.product.variants.length > 0) {
          variantId = window.product.variants[0].id;
        }

        if (!variantId) {
          const productData = document.querySelector('[data-product-json]');
          if (productData) {
            const product = JSON.parse(productData.textContent);
            variantId = product.variants[0].id;
          }
        }

        if (!variantId) throw new Error("No variant selected");

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!response.ok) throw new Error("Failed to add to cart");

        button.textContent = "Added!";
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);

        document.dispatchEvent(new CustomEvent("cart:refresh"));

      } catch (error) {
        console.error("Error adding to cart:", error);
        button.textContent = "Error";
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      }
    });
  }
});


// Observer and add to cart for product sticky header js

//  sticky product header js


// new code

document.addEventListener('DOMContentLoaded', function() {
  const variantButtons = document.querySelectorAll('.product_options_wrapper .variant-option__button-label');
  const notifyButton = document.querySelector('.notify_me_custom_btn_itg');
  
  if (!variantButtons.length || !notifyButton) return;

  // Function to check availability
  function checkVariantAvailability() {
    const selectedInput = document.querySelector('.product_options_wrapper input[type="radio"]:checked');
    if (!selectedInput) return;

    const isAvailable = selectedInput.getAttribute('data-option-available') === 'true';

    if (!isAvailable) {
      notifyButton.style.display = 'block';
    } else {
      notifyButton.style.display = 'none';
    }
  }

  // Event: Variant option clicked
  variantButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Delay of 1.5 seconds after clicking a variant
      setTimeout(checkVariantAvailability, 1500);
    });
  });

  // Event: Page load (run after 1.5 seconds)
  setTimeout(checkVariantAvailability, 1500);
});

document.addEventListener("click", function (e) {
     
    // Check if the clicked element is the add-to-cart button
    const addToCartBtn = e.target.closest('.add-to-cart-button[name="add"][ref="addToCartButton"]');

    if (addToCartBtn) {

        // Check if its parent is inside #quick-add-modal-content
        const isInsideQuickModal = addToCartBtn.closest('#quick-add-modal-content');

        if (isInsideQuickModal) {

            // Prevent default click behavior

            // Wait 2 seconds
            setTimeout(() => {

                // Check body class
                if (document.body.classList.contains("upcartPopupShow")) {
                }
                    // Find close button inside modal and trigger click
                    const closeBtn = document.querySelector('.itg_quick_modal_wrapper [ref="closeButton"]');

                    if (closeBtn) {
                        closeBtn.click();
                    }
                     const openCartBtn_ = document.querySelector('[data-bc-cart-trigger]');
                    if (openCartBtn_) {
                        openCartBtn_.click();
                    }
            }, 100);
        }
    }
});


// Image Lazy load js

document.addEventListener("DOMContentLoaded", () => {
  const lazyImages = document.querySelectorAll('img[data-src]');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        obs.unobserve(img);
      }
    });
  });

  lazyImages.forEach(img => observer.observe(img));
});



// bc 2026-10-02: ITG cart icons open Horizon's native cart drawer (replaces the removed UpCart app).
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-bc-cart-trigger]');
  if (!trigger) return;
  var drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') {
    e.preventDefault();
    drawer.open();
  }
});

// bc 2026-10-02: plain <form action="/cart/add"> blocks (home featured product) used to be hijacked by the
// UpCart app. Add via AJAX instead of leaving the page, then fire the theme's own cart:update event so the
// native drawer opens (auto-open) and the cart items + header bubble re-render.
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!/\/cart\/add\/?$/.test(form.getAttribute('action') || '')) return;
  if (form.closest('product-form-component')) return;          // Horizon handles its own forms
  if (!document.querySelector('cart-drawer-component')) return; // cart page / no drawer: normal submit
  e.preventDefault();
  var btn = form.querySelector('[type="submit"]');
  if (btn) btn.setAttribute('aria-busy', 'true');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fd = new FormData(form);
  fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
    .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
    .then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'bc-raw-form', data: { source: 'bc-raw-form', itemCount: cart.item_count } }
      }));
    })
    .catch(function () { form.submit(); })                       // any failure: fall back to the normal page flow
    .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
});

// bc 2026-10-02: attach video files only where they are needed (snippets/bc-video).
// data-bc-gate = desktop|mobile → only that device loads the file; data-bc-video="lazy" → when near the viewport.
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  function gateOk(v) { var g = v.getAttribute('data-bc-gate'); return !g || (g === 'desktop') === mq.matches; }
  function attach(v) {
    if (v.dataset.bcAttached || !gateOk(v)) return;
    v.dataset.bcAttached = '1';
    v.preload = 'auto';
    var hls = v.getAttribute('data-src-hls');
    v.src = (hls && v.canPlayType('application/vnd.apple.mpegurl')) ? hls : v.getAttribute('data-src');
    var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    v.addEventListener('loadeddata', tryPlay, { once: true });
    v.load(); tryPlay();
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.dataset.bcSeen = '1'; poster(e.target); attach(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '250px 0px' }) : null;
  // bc 2026-10-05: poster per device (snippets/bc-video sets it inline; this covers resize/rotation).
  function poster(v) {
    // Lazy (below-the-fold) videos get their poster only once they are near the viewport.
    if (!gateOk(v) || (v.getAttribute('data-bc-video') === 'lazy' && !v.dataset.bcSeen)) return;
    var p = (!mq.matches && v.getAttribute('data-poster-mobile')) || v.getAttribute('data-poster');
    if (p && v.getAttribute('poster') !== p) v.poster = p;
  }
  // bc 2026-10-05: the hero file used to start downloading at DOMContentLoaded, before the page had painted,
  // so a 6 MB video competed with the stylesheets, fonts and poster for the connection. It now starts right
  // after the first painted frame (two animation frames; 3 s fallback for background tabs). Same file, same
  // quality; the poster (the video's first frame) is on screen in the meantime.
  function afterFirstPaint(fn) {
    var done = false, go = function () { if (!done) { done = true; fn(); } };
    if (document.visibilityState === 'hidden') { setTimeout(go, 0); return; }
    requestAnimationFrame(function () { requestAnimationFrame(function () { setTimeout(go, 0); }); });
    setTimeout(go, 3000);
  }
  function init(scope) {
    (scope || document).querySelectorAll('video[data-bc-video]').forEach(function (v) {
      var lazy = v.getAttribute('data-bc-video') === 'lazy';
      if (lazy && io) { io.observe(v); return; }
      if (lazy) v.dataset.bcSeen = '1';
      poster(v);
      afterFirstPaint(function () { attach(v); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  // Theme editor: a re-rendered section brings new <video> elements without a page load.
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelectorAll) init(e.target); });
  // Back/forward cache: a restored page can come back with its autoplay videos paused.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('video[data-bc-attached]').forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  });
  mq.addEventListener('change', function () {
    document.querySelectorAll('video[data-bc-video]').forEach(poster);
    document.querySelectorAll('video[data-bc-video][data-bc-gate]').forEach(attach);
  });
})();

// bc 2026-10-02: Shopify's accelerated-checkout host reserves a full button row (52px + 8px gap) for a
// "personalized" Shop Pay button even when Shopify decides not to show it (non-cart templates, buyer not
// recognized). The row lives in a closed shadow root, so collapse it from outside: pull the host up by the
// blank height inside its wrapper and let the wrapper clip it (overflow:hidden also stops the negative margin
// from collapsing through to the wrapper and overlapping the Check out button). Re-evaluates whenever the host
// or a wallet resizes; if Shop Pay renders later for a recognized buyer the gap is 0 and the styles reset.
(function () {
  function collapse(host) {
    var wrap = host.parentElement;
    if (!wrap) return;
    var kids = Array.prototype.slice.call(host.children).filter(function (c) { return /-button$/i.test(c.tagName); });
    var shown = kids.filter(function (c) { return c.getBoundingClientRect().height > 0; });
    var reset = function () { host.style.marginTop = ''; host.style.display = ''; wrap.style.overflow = ''; };
    if (!shown.length) return reset();
    var wasMargin = parseFloat(host.style.marginTop) || 0;
    var gap = Math.round(shown[0].getBoundingClientRect().top - host.getBoundingClientRect().top);
    if (gap > 8) {
      wrap.style.overflow = 'hidden';
      host.style.display = 'block';
      host.style.marginTop = (-gap) + 'px';
    } else if (gap <= 0 && wasMargin < 0) {
      reset();
    }
  }
  function scan() {
    document.querySelectorAll('cart-drawer-component shopify-accelerated-checkout-cart').forEach(function (host) {
      if (!host.__bcGap) {
        host.__bcGap = true;
        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(function () { collapse(host); });
          ro.observe(host);
          Array.prototype.forEach.call(host.children, function (c) { ro.observe(c); });
        }
      }
      collapse(host);
    });
  }
  document.addEventListener('cart:update', function () { setTimeout(scan, 300); setTimeout(scan, 1500); });
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-drawer-component')) { setTimeout(scan, 50); setTimeout(scan, 1000); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
